import * as React from "react";

function Logo1(props) {
  return (
    <svg viewBox="0 0 27 38.81" {...props} role="img" aria-labelledby="title">
      <title>名古屋市立大学のロゴ</title>
      <defs>
        <style>{".cls-logo1-1{fill:#dd1d3c}"}</style>
      </defs>
      <g id="logo1" data-name="Layer 2">
        <g id="logo1-2" data-name="Layer 1">
          <path
            className="cls-logo1-1"
            d="M10.12 0v9L3.38 0H0v13.5h3.38v-9l6.74 9h3.38V0h-3.38z"
          />
          <path
            className="cls-logo1-1"
            d="M20.25 3.38H27V0h-6.75a6.75 6.75 0 000 13.5H27v-3.37h-6.75a3.38 3.38 0 110-6.75"
          />
          <path
            d="M23.62 15.19v10.12a5.06 5.06 0 11-10.12 0V15.19H0v10.12a13.5 13.5 0 0027 0V15.19z"
            fill="#231815"
          />
        </g>
      </g>
    </svg>
  );
}

const MemoLogo1 = React.memo(Logo1);
export default MemoLogo1;
